import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import {Message, SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {TemplateService} from '../../services/template.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {CALENDAR_LOCALE, RD_DOC_TYPE} from '../../services/constant';
import * as moment from 'moment';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-tax-report',
  templateUrl: './submit-to-rd.component.html',
  styleUrls: ['./submit-to-rd.scss'],
  providers: [TemplateService]
})
export class SubmitToRdComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;

  calendarLocale;
  selectedCompany: SelectItem[];
  company: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  canDownloadZipOption: any;
  selectedCanDownloadZip: SelectItem[];
  msgs: Message[] = [];
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  defaultStartDate: string;
  defaultEndDate: string;
  clickedStartDate: string;
  clickedEndDate: string;
  allBranch = true;
  allDocType = true;
  notSubmittedCompletely: any;
  branch: any;
  branchSuggest: any;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allBranchSelected = [];
  selectedValues = [];
  indexArray = [];
  test: any;
  tableData: any;
  tableDataDisplay: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  loading_all_excel = false;
  cancel_loading_all_excel = false;
  loading_all_excel_message = '';
  no_data = true;
  value = 0;
  sum_docs_count = 0;
  loading_all_excel_progress = 0;
  errorMsg = '';
  monthList = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม',
    'พฤศจิกายน', 'ธันวาคม'];
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];

  selectedMonth: any;
  selectedYear: any;

  allExcelCount: number;
  allExcelCurrent = 0;

  index = 0;
  tableArray = [];
  modalData: any;

  branchList: any = null;
  selectedBranch: SelectItem[];
  allBranchList: any = null;
  docTypeList: any = null;

  loading_excel_report = false;

  sortBy: string;
  sortMode: string;
  is_TH = false;
  sortAscending = true;

  rdDocumentType: any;
  selectedRdDocumentType: any;

  tableCol = [
    // { field: 'group', header: 'ประเภทธุรกิจ' },
    {field: 'branch', header: 'ชื่อสาขา'},
    {field: 'rd_doc_type', header: 'ประเภทเอกสาร'},
    // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
    {field: 'total_doc', header: 'จำนวนเอกสาร'}
  ];

  rd_doc_types = RD_DOC_TYPE;
  listInvNoIssueDate = {};
  listOfTaxIdLists: {};
  sendToRdSuccess = false;
  sendToRdMessage = '';
  subs: Subscription;

  @ViewChild('tt') table: any;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
    this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'th') {
        this.is_TH = true;
      }
      if (event.lang === 'en') {
        this.is_TH = false;
      }
      this.populateDropdown();
    });
    this.loadTexts();
    this.populateDropdown();
    this.searchData();
  }

  loadTexts() {
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      const documentData = this.template.getDropdown();
      documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
      this.rdDocumentType = documentData;
      this.selectedRdDocumentType = null;
      this.loadInput();
    });
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  populateDropdown() {
    this.monthListDropdown = [];
    this.monthListDropdown.push(
      {label: this.translate.instant('MONTH.JANUARY'), value: 1},
      {label: this.translate.instant('MONTH.FEBRUARY'), value: 2},
      {label: this.translate.instant('MONTH.MARCH'), value: 3},
      {label: this.translate.instant('MONTH.APRIL'), value: 4},
      {label: this.translate.instant('MONTH.MAY'), value: 5},
      {label: this.translate.instant('MONTH.JUNE'), value: 6},
      {label: this.translate.instant('MONTH.JULY'), value: 7},
      {label: this.translate.instant('MONTH.AUGUST'), value: 8},
      {label: this.translate.instant('MONTH.SEPTEMBER'), value: 9},
      {label: this.translate.instant('MONTH.OCTOBER'), value: 10},
      {label: this.translate.instant('MONTH.NOVEMBER'), value: 11},
      {label: this.translate.instant('MONTH.DECEMBER'), value: 12}
    );
    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  canUserDownloadDoc() {
    // return this.authService.isAccountantAdmin();
    return true;
  }

  loadInput() {
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.selectedCompany = null;

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    this.homeproGroup = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompanyGroup().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    this.canDownloadZipOption = [{
      label: 'ทั้งหมด',
      value: null
    }, {
      label: 'เฉพาะที่ตรวจสอบจากบัญชีแล้ว',
      value: true
    }, {
      label: 'เฉพาะที่ยังไม่ได้ตรวจสอบ',
      value: false
    }];

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate == this.selectedCompany)
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
    });
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.searchData(params);
  }

  searchBranch(event) {
    if (this.branchList == null) {
      this.apiService.getBranch().subscribe(
        (data) => {
          this.branchList = data;
          this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
      );
    } else {
      this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.apiService.getDocumentType().subscribe(
        (result) => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
      );
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
    }
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim();

    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      const data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  selectAllBranch() {
    this.branch = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  canUserApproveDoc() {
    return this.authService.isAccountant();
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    this.allBranchSelected = [];
    this.allDocumentType = [];
    _.forEach(this.branch, (data) => {
      // this.allBranchSelected = [];
      this.allBranchSelected.push(_.toNumber(data.id));
    });
    _.forEach(this.documentType, (data) => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(data.id));
    });

    this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
    this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
    const sniffTargetArr: string[] = [];
    if (this.selectedCompany) {
      sniffTargetArr.push('FILTER.COMPANY');
    }

    if (this.selectedBranch) {
      sniffTargetArr.push('FILTER.BRANCH');
    }

    if (this.selectedRdDocumentType) {
      sniffTargetArr.push('FILTER.DOCUMENT-TYPE');
    }

    if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
      sniffTargetArr.push('FILTER.DATE');
    }

    if (this.notSubmittedCompletely) {
      sniffTargetArr.push('SUBMIT-TO-RD.ITEMS-NOT-SENT-COMPLETELY');
    }

    const data = {
      not_submitted_completely: this.notSubmittedCompletely,
      start_date: moment(this.startDate).format('YYYY-MM-DD'),
      end_date: moment(this.endDate).format('YYYY-MM-DD'),
      group_id: this.selectedHomeproGroup,
      company_id: this.selectedCompany ? this.selectedCompany : null,
      can_download_zip: this.selectedCanDownloadZip,
      document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
      // branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
      branch_id: this.selectedBranch ? [this.selectedBranch] : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType ? this.selectedRdDocumentType : null
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.apiService.postSubmitToRd(data, params).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.tableDataDisplay = this.tableData;
        this.sum_docs_count = result.sum_docs_count;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;

        this.selectedValues = [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.selectedValues.push(false);
        }

        // copy array in "approved_but_not_in_ebxml_taxdataid_list" field from result.results to listOfTaxIdLists object
        // listOfTaxIdLists is an object of arrays
        this.listOfTaxIdLists = result.results.map(function (item) {
          return item['not_in_ebxml_taxdataid_list'];
        });

        this.listInvNoIssueDate = result.results.map(function (item) {
          return item['not_in_ebxml_inv_no_issue_dt_list'];
        });
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );

    if (params == null) {
      const sniffTarget = sniffTargetArr.join(', ');
      this.sniff('SEARCH', sniffTarget);
    }
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  confirmDocument(event, content, index, data) {
    event.currentTarget.blur();
    event.preventDefault();
    this.modalData = data;
    this.modal = this.modalService.open(content, {centered: true});
  }

  confirm() {
    if (this.modalData.uploaded === false) {
      const params = {
        approved: true,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    } else {
      const params = {
        approved: false,
        month: this.selectedMonth,
        year: this.selectedYear,
        group: this.modalData.group,
        rd_document_type: this.modalData.rd_document_type,
        document_type: this.modalData.document_type,
        corporate_branch: this.modalData.corporate_branch,
      };
      this.apiService.approveUploadSale(params).subscribe(
        (result) => {
          this.modal.close();
        }
      );
    }
  }

  revertBack() {
    this.searchData();
    this.modal.close();
  }

  clearData() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.selectedCompany = null;
    this.selectedCanDownloadZip = null;
    this.selectedRdDocumentType = null;
    this.selectedHomeproGroup = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.notSubmittedCompletely = false;
    this.selectedBranch = null;

    this.searchButtonClicked();
  }

  getExcelFileName(data, headerIssueDateDash, index) {
    const file_name = 'submit_rd_report' + ' ' + headerIssueDateDash;
    return file_name + '.xlsx';
  }

  clearBranch() {
    this.allBranchSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' '
        + this.translate.instant('COMMON.CORRECT');
    }
  }

  selectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      // this.selectedValues[i] = (this.tableData[i].can_download_zip === true);
      this.selectedValues[i] = !this.tableData[i].submit_completely;
    }
  }

  deselectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = false;
    }
  }

  canSelectAll() {
    return this.tableData.filter(data => data.can_download_zip === true).length > 0;
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }

  DownloadSelected(content) {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (this.selectedValues[i]) {
        this.tableArray.push(this.tableData[i]);
        this.indexArray.push(i);
      }
    }

    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
      this.allExcelCount = this.tableArray.length;
      this.cancel_loading_all_excel = false;
      this.download(this.tableArray);
    }
  }

  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.apiService.getExcelReport(params).subscribe(
      (obj) => {
        const filename = 'tax_report_' + this.selectedMonth + '_' + this.selectedYear + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
        this.sniff('DOWNLOAD_XLS', filename);
        this.loading_excel_report = false;
      },
      error => {
        this.loading_excel_report = false;
      }
    );
  }

  download(tableArray) {

    // check if tableArray is empty
    if (!Array.isArray(tableArray) || !tableArray.length) {
      this.loading_all_excel = false;
      this.loading_all_excel_message = 'Download ' + this.translate.instant('COMMON.COMPLETE');

      for (let i = 0; i < tableArray.length; i++) {
        tableArray[i].uploaded = true;
      }

      return;
    }

    if (this.cancel_loading_all_excel) {
      return;
    }

    this.loading_all_excel = true;

    const dateArray = tableArray[0].header_issue_date.split('/');
    const headerIssueDay = dateArray[0];
    const headerIssueMonth = dateArray[1];
    const headerIssueYear = dateArray[2];
    const headerIssueDateDash = headerIssueYear + '-' + headerIssueMonth + '-' + headerIssueDay;

    const params = {
      header_issue_dt: headerIssueDateDash,
      rd_document_type: tableArray[0].rd_document_type,
      corporate_branch: tableArray[0].corporate_branch,
      group: tableArray[0].group,
      document_type: tableArray[0].document_type,
    };

    this.apiService.getAllExcelFile(params).subscribe(
      (obj) => {
        if (this.cancel_loading_all_excel) {
          return;
        }

        // remove the first element in indexArray and store the value in the variable index
        const downloadIndex = this.indexArray.shift();

        const filename = this.getExcelFileName(tableArray[0], headerIssueDateDash, downloadIndex + 1);

        this.apiService.createDownloadFile(obj, filename);
        this.sniff('DOWNLOAD_XLS', filename);
        this.allExcelCurrent++;
        this.loading_all_excel_progress = (this.allExcelCurrent / this.allExcelCount) * 100;

        // removes the first element in tableArray
        tableArray.shift();

        setTimeout(() => {
          this.download(tableArray);
        }, 1000);
      },
      error => {
        this.loading_all_excel = false;
        this.loading_all_excel_message = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_excel = true;
    this.loading_all_excel = false;
    this.allExcelCurrent = 0;
    this.loading_all_excel_progress = 0;
    this.searchButtonClicked();
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }

    // this.searchData();
  }

  submitCheckedToRd(content) {
    const taxDataIdSet = new Set();
    const invNoIssueDateSet = new Set();

    // get only indexes that have been selected
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (this.selectedValues[i]) {
        for (let j = 0; j < this.listOfTaxIdLists[i].length; j++) {
          taxDataIdSet.add(this.listOfTaxIdLists[i][j]);
          invNoIssueDateSet.add(this.listInvNoIssueDate[i][j]);
        }
      }
    }

    const taxDataIdArray = Array.from(taxDataIdSet.values());

    if (taxDataIdArray.length === 0) {
      this.sendToRdMessage = this.translate.instant('SUBMIT-TO-RD.NO-DATA');
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
    } else {
      const params = {
        taxDataIdArray: taxDataIdArray
      };
      this.apiService.submitCheckedToRd(params).subscribe(
        (result) => {

          this.sendToRdMessage = this.translate.instant('SUBMIT-TO-RD.SUBMIT-ERROR');

          if (result.message === 'Submit to RD successful') {
            this.sendToRdMessage = this.translate.instant('SUBMIT-TO-RD.SUBMIT-SUCCESS');
          }

          this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});

          for (const invNoIssueDate of Array.from(invNoIssueDateSet)) {
            this.sniff('SUBMIT_RD', invNoIssueDate);
          }
        },

        error => {
        }
      );
    }
  }

  sortColumn(columnName) {
    if (this.sortAscending) {
      this.sortAscending = false;
      this.tableDataDisplay = this.tableData.sort(function (a, b) {

        // handle null value
        if (a[columnName] !== null && b[columnName] === null) {
          return 1;
        }
        if (a[columnName] === null && b[columnName] !== null) {
          return -1;
        }
        if (a[columnName] === null && b[columnName] === null) {
          return 0;
        }

        return a[columnName] < b[columnName] ? -1 : a[columnName] > b[columnName] ? 1 : 0;
      });
    } else {
      this.sortAscending = true;
      this.tableDataDisplay = this.tableData.sort(function (a, b) {

        // handle null value
        if (a[columnName] !== null && b[columnName] === null) {
          return -1;
        }
        if (a[columnName] === null && b[columnName] !== null) {
          return 1;
        }
        if (a[columnName] === null && b[columnName] === null) {
          return 0;
        }

        return a[columnName] < b[columnName] ? 1 : a[columnName] > b[columnName] ? -1 : 0;
      });
    }
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'SUBMIT_RD',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/submit-to-rd/submit-to-rd.component.ts